module.exports = {
	"header": "E-commerce platform wants to give the power to the merchants",
	"date": "2021/06/11",
	"imgSrc": "7.jpg",
	"imgAlt": "E-commerce platform wants to give the power to the merchants",
	"ingress": "By: Di Digital (in Swedish)",
	"externalLink": "https://www.di.se/digital/e-handelsplattformen-vill-ge-makten-till-handlarna-backas-av-olof-faxander/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/7/article.json
// module id = 97
// module chunks = 0